<form [formGroup]="challengeQuestionForm" (ngSubmit)="onSubmit()">
  <harp-input [inputConfig]="challengeQuestionAnswerConfig"></harp-input>

  <button
    class="btn btn-primary btn-lg harp-button-margin"
    type="button"
    [disabled]="challengeQuestionForm.invalid"
    type="submit"
  >
    Next
  </button>
</form>
